import React from 'react';
import Icon from '../../../components/AppIcon';

const ForumCategoryCard = ({ category, onClick }) => {
  return (
    <div 
      onClick={() => onClick(category)}
      className="bg-card border border-border rounded-lg p-6 hover:shadow-wellness-md transition-wellness cursor-pointer group"
    >
      <div className="flex items-start space-x-4">
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${category?.color} group-hover:scale-105 transition-wellness`}>
          <Icon name={category?.icon} size={24} color="white" />
        </div>
        
        <div className="flex-1 min-w-0">
          <h3 className="font-heading font-semibold text-foreground text-lg mb-2 group-hover:text-primary transition-wellness">
            {category?.name}
          </h3>
          <p className="text-muted-foreground text-sm mb-3 line-clamp-2">
            {category?.description}
          </p>
          
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4 text-sm text-muted-foreground">
              <div className="flex items-center space-x-1">
                <Icon name="MessageSquare" size={14} />
                <span>{category?.postCount} posts</span>
              </div>
              <div className="flex items-center space-x-1">
                <Icon name="Users" size={14} />
                <span>{category?.memberCount} members</span>
              </div>
            </div>
            
            {category?.hasNewPosts && (
              <div className="w-2 h-2 bg-accent rounded-full animate-breathing"></div>
            )}
          </div>
          
          {category?.lastActivity && (
            <div className="mt-2 text-xs text-muted-foreground">
              Last activity: {category?.lastActivity}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForumCategoryCard;